import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import store from "../../../state/store";
import { getGeneCardData } from "../../../state/selectors/CardsUI.selectors";
import IconExternalLink from "../../../../../assets/images/svg/external-link.svg";
import { getACMGThrottling } from "../../../state/selectors/ACMGComponent.selectors";
import ComponentPanel from "../../../components/atoms/ComponentPanel/ComponentPanel";

const Genes = ({ genesInfo, acmgThrottlingInfo }) => {
  const componentTitle = "Genes";
  if (genesInfo) {
    return (
      <div className="varsome-result-fixed">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title={componentTitle}
            content={
              <div className="tw-bg-white tw-text-sm tw-p-3">
                <ul>
                  {genesInfo.cardContent.map((gene, index) => (
                    <li key={`gene${index}`}>
                      {index === 0 &&
                      genesInfo?.componentContent?.length > 0 ? (
                        <b>
                          <a
                            className="1234"
                            target="_blank"
                            href={`${
                              store.getState().varsomeHost
                            }/gene/${gene}`}
                          >
                            {gene}{" "}
                            <IconExternalLink className="geneInlineIcon" />
                          </a>{" "}
                        </b>
                      ) : (
                        <>
                          <a
                            target="_blank"
                            href={`${
                              store.getState().varsomeHost
                            }/gene/${gene}`}
                          >
                            {gene}{" "}
                            <IconExternalLink className="geneInlineIcon" />
                          </a>{" "}
                        </>
                      )}
                      {index === 0 ? (
                        <i className="tw-text-3xs">
                          {!acmgThrottlingInfo &&
                            "(selected by the Germline Variant classifier)"}
                        </i>
                      ) : (
                        ""
                      )}
                    </li>
                  ))}
                  {genesInfo.componentContent.map((gene, index) => (
                    <li key={`gene${index}`}>
                      <a
                        target="_blank"
                        href={`${store.getState().varsomeHost}/gene/${
                          gene.symbol
                        }`}
                      >
                        {gene.symbol}{" "}
                        <IconExternalLink className="geneInlineIcon" />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title={componentTitle}
          content={
            <div className="tw-bg-white tw-text-sm tw-p-3">
              <h4>No Genes found</h4>
            </div>
          }
        />
      </div>
    </div>
  );
};

Genes.propTypes = {
  genesInfo: PropTypes.shape({
    componentContent: PropTypes.arrayOf(
      PropTypes.shape({ symbol: PropTypes.string })
    ),
    cardContent: PropTypes.arrayOf(PropTypes.string),
  }),
  acmgThrottlingInfo: PropTypes.shape({
    throttling_msg: PropTypes.string,
  }),
};

Genes.defaultProps = {
  genesInfo: null,
  acmgThrottlingInfo: null,
};

const mapStateToProps = (state) => {
  return {
    genesInfo: getGeneCardData(state),
    acmgThrottlingInfo: getACMGThrottling(state),
  };
};

export default connect(mapStateToProps)(Genes);
